import { IdentityClientSettings } from '@gsgroup/gsgroup-react-ui';
import { buildHttpHeaders } from '../../utils/buildHttpHeaders';
import { AppSettings } from '../../@types/AppSettings';

const PATH = 'app-settings'

export async function getAppSettingsAsync() {

  try {
      const response = await fetch(`/${PATH}`);

      if (response.status !== 200) {
          throw new Error(await response.text());
      }
      
      const appSettings: AppSettings = await response.json();

      return appSettings;
  } catch (error) {
      console.log(error);

      throw error;
  }
}

export async function getHandymanSettingAsync(setting: string, backendHeader: string, signal?: AbortSignal) {
  const url = `settings/${setting}`;
  try {
    const response = await fetch(url, {
      headers: buildHttpHeaders(backendHeader),
      signal: signal
    });

    if (response.status !== 200) {
      throw new Error(await response.text());
    }

    const result = await response.text();

    return result;
  } catch (error) {
    console.log(error);

    throw error;
  }
}